import DetailListPage from "@/pages/DetailListPage";

export default function Services() {
  return (
    <DetailListPage
      collection="services"
      eyebrow="How We Deliver"
      title="Our Services"
      subtitle="From consulting and procurement to installation, managed SOC operations, AMC and training — end-to-end delivery for mission-critical technology programmes."
      heroImage="/generated/install.jpg"
    />
  );
}
